import { createApp } from 'vue';
import App from './App.vue';
import './styles.css';
import './party-theme.css';
import './motion.css';
createApp(App).mount('#app');
